import React from "react";
import { motion } from "framer-motion";
import { useLang } from "@/context/LanguageContext";
import { T } from "@/content/site";

export default function Testimonials() {
  const { t } = useLang();
  return (
    <section id="testimonials" data-testid="testimonials-section" className="relative bg-[#0B0B0B] py-[140px] md:py-[180px]">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="overline mb-8">
          <span className="inline-block w-8 h-px bg-[color:var(--sacrvm-gold)] align-middle mr-3" />
          {t(T.testimonials.overline)}
        </motion.div>
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1 }}
          className="font-serif text-white text-[36px] md:text-[64px] leading-[1.05] tracking-[-0.01em] max-w-[1000px] mb-20"
        >
          {t(T.testimonials.title)}
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-14">
          {T.testimonials.items.map((tm, i) => (
            <motion.figure
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.9, delay: i * 0.1 }}
              className="border-t border-white/15 pt-8"
              data-testid={`testimonial-${i}`}
            >
              <div className="font-serif text-[color:var(--sacrvm-gold)] text-[46px] leading-none">&ldquo;</div>
              <blockquote className="font-serif text-white text-[22px] md:text-[26px] leading-[1.35] mt-2">
                {t(tm.quote)}
              </blockquote>
              <figcaption className="mt-8">
                <div className="font-serif text-white text-[16px]">{tm.author}</div>
                <div className="text-[11px] tracking-[0.24em] uppercase text-[color:var(--sacrvm-text-muted)] mt-1">
                  {t(tm.role)}
                </div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
